import styles from "./DesignBoxTabBar.module.css";
import warning_icon from "../../assets/images/icons/warning_icon.png";

const DesignBoxTabBar = ({
  active,
  setActive,
  showWarningIconOnUneditedTab,
  showWarningIconOnConfirmedTab,
}) => {
  return (
    <>
      <div className={styles.design_box_tab_bar_main_div}>
        {showWarningIconOnUneditedTab && (
          <img
            className={styles.button_image_warning}
            style={{ left: "50px", top: "19px" }}
            src={warning_icon}
            alt="warning"
          />
        )}
        <button
          onClick={() => setActive(1)}
          style={{
            backgroundColor: active === 1 ? "#EFEEE5" : "white",
            borderTop: active === 1 ? "none" : "1px solid #70707066",
            borderLeft: active === 1 ? "none" : "1px solid #70707066",
            borderRight: active === 1 ? "none" : "1px solid #70707066",
            cursor: "pointer",
          }}
        >
          未編集
        </button>
        <button
          onClick={() => setActive(2)}
          style={{
            backgroundColor: active === 2 ? "#EFEEE5" : "white",
            borderTop: active === 2 ? "none" : "1px solid #70707066",
            borderLeft: active === 2 ? "none" : "1px solid #70707066",
            borderRight: active === 2 ? "none" : "1px solid #70707066",
            cursor: "pointer",
          }}
        >
          編集済み
        </button>
        <div className={styles.button_div_container}>
          {showWarningIconOnConfirmedTab && (
            <img
              className={styles.button_image_warning}
              style={{ left: "10px", top: "19px" }}
              src={warning_icon}
              alt="warning"
            />
          )}
          <button
            onClick={() => setActive(3)}
            style={{
              backgroundColor: active === 3 ? "#EFEEE5" : "white",
              borderTop: active === 3 ? "none" : "1px solid #70707066",
              borderLeft: active === 3 ? "none" : "1px solid #70707066",
              borderRight: active === 3 ? "none" : "1px solid #70707066",
              cursor: "pointer",
            }}
          >
            完成デザイン確認
          </button>
        </div>
      </div>
    </>
  );
};

export default DesignBoxTabBar;
